import { API_BASE } from 'shared/constants/Api'

export const COMPANY_INFO = `${API_BASE}/api/v2/ident-service/api/v2/client_companies/`

export const INVOICE_SETTINGS = `${API_BASE}/api/v2/invoice_settings/`

export const GET_USER_INFO = `${API_BASE}/api/v2/ident-service/api/v2/users/session_owner`
export const UPDATE_USER_INFO = `${API_BASE}/api/v2/ident-service/api/v2/users/`
